<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div>
  <app-fde-settings [d3ePolicy]="d3ePolicy" (onChanged)="onFdeInfoChanged()"></app-fde-settings>
</div>
